import { createSlice } from '@reduxjs/toolkit';
import { COLOR_DEFAULT_LIST } from '../../config/dataConfig/FJCommonDataConfig';

export const FJSliceColorCommon = createSlice({
    name: 'colorCommon',
    initialState: {
        selectColorList: [],
        defaultColorList: COLOR_DEFAULT_LIST,

        activeColor: '#000000',
    },

    reducers: {
        setSliceSelectColorList: (state, action) => {
            state.selectColorList = action.payload;
        },

        setSliceActiveColor: (state, action) => {
            state.activeColor = action.payload;
        },
    },
});

export const { setSliceSelectColorList, setSliceActiveColor } = FJSliceColorCommon.actions;
export default FJSliceColorCommon.reducer;
